import { MainPage } from '../widgets/landing/ui/Landing';

export const getHomeRoute = role => {
  if (role === 'client') return '/acl';
  else return '/home';
};

const Home = () => {
  return <MainPage></MainPage>;
};

export const getServerSideProps = async context => {
  // if (process.env.NEXT_PUBLIC_ENV !== 'productionPolygon') {
  //   return {};
  // }

  // return {
  //   redirect: {
  //     destination: '/preRegistration',
  //     permanent: false
  //   }
  // };

  return { props: {} };
};

export default Home;
